<template>
  <div class="">

    <div class="form-group">
      <label for="weight_weight">وزن</label>
      <input required
             v-model="formData.weight"
             type="number"
             id="weight_weight"
             class="form-control text-left">
    </div>

    <div class="form-group">
      <label for="weight_weight">وزن با جعبه</label>
      <input required
             :min="formData.weight"
             v-model="formData.package_weight"
             type="number"
             id="weight_weight"
             class="form-control text-left">
    </div>

  </div>
</template>

<script>
export default {
  name: "BasalamWeight",
  props: {
    formData: {},
    basalamProduct: {
      default: null
    }
  },
  mounted() {
    if (this.basalamProduct != null) {

      if (this.basalamProduct.revision == null) {
        this.formData.weight = this.basalamProduct.net_weight
        this.formData.package_weight = this.basalamProduct.packaged_weight
      } else {
        this.formData.weight = this.basalamProduct.revision.data.net_weight
        this.formData.package_weight = this.basalamProduct.revision.data.packaged_weight
      }

    }
  }
}
</script>

<style scoped>

</style>